import type { AriaAttributes } from "react";

export type ControlStateProps = Pick<
  AriaAttributes,
  "aria-disabled" | "aria-invalid"
> & {
  disabled?: boolean | undefined;
  "data-invalid"?: boolean | undefined;
  state?: "default" | "disabled" | "invalid" | null | undefined;
};

export function isControlDisabled(props: ControlStateProps) {
  return (
    props.disabled ||
    props["aria-disabled"] === true ||
    props["aria-disabled"] === "true" ||
    props.state === "disabled"
  );
}

export function getControlState(props: ControlStateProps) {
  if (isControlDisabled(props)) {
    return "disabled";
  }

  const invalid = props["aria-invalid"];

  if (
    (invalid !== undefined && invalid !== false && invalid !== "false") ||
    props["data-invalid"] ||
    props.state === "invalid"
  ) {
    return "invalid";
  }

  return "default";
}
